import React from "react";
import { Link, useLocation } from "react-router-dom";
import { navItems } from "../../static/data";

const Navbar = ({ active }) => {
  const location = useLocation();

  const isActive = (item, index) => {
    // Primary: path-based check
    if (item.url === "/" && location.pathname === "/") return true;
    if (item.url !== "/" && location.pathname.startsWith(item.url)) return true;
    // Fallback: prop-based for legacy pages
    if (active !== undefined && active === index + 1) return true;
    return false;
  };

  return (
    <div className="flex flex-col 800px:flex-row 800px:items-center 800px:gap-1 space-y-1 800px:space-y-0">
      {navItems.map((item, index) => (
        <Link
          key={index}
          to={item.url}
          className={`${
            isActive(item, index)
              ? "text-accent-500 800px:border-b-2 800px:border-accent-500 font-semibold"
              : "text-secondary-300 hover:text-white"
          } block px-3 py-3 800px:px-2 800px:py-0 text-[13px] font-medium transition-colors duration-200 800px:pb-1 whitespace-nowrap tracking-wide uppercase`}
        >
          {item.title}
        </Link>
      ))}
    </div>
  );
};

export default Navbar;
